import { render, staticRenderFns } from "./app-layout.vue?vue&type=template&id=9bd68750"
import script from "./app-layout.vue?vue&type=script&lang=js"
export * from "./app-layout.vue?vue&type=script&lang=js"
import style0 from "./app-layout.vue?vue&type=style&index=0&id=9bd68750&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports